import React from 'react';
import { useTranslation } from 'react-i18next';
import Textarea from '@wix/da-shared-react/pkg/Textarea';
import { useSubmitField } from '../../../hooks/useSubmitField';

import s from './OriginalUrlsWhitelistField.scss';

const OriginalUrlsWhitelistField: React.FC<{}> = () => {
  const { t } = useTranslation();
  const {
    id,
    field: { onChange, value },
  } = useSubmitField('originalUrlsWhitelist', {
    initAdapter: ({ app }) => app?.originalUrlsWhitelist ?? '',
    submitAdapter: ({ originalUrlsWhitelist }) => ({
      original_urls_whitelist: originalUrlsWhitelist,
    }),
  });

  return (
    <Textarea
      id={id}
      label={t('deviationSubmit.form.app.originalUrlsWhitelist.label')}
      subLabel={t('deviationSubmit.form.app.originalUrlsWhitelist.hint')}
      onChange={onChange}
      value={value}
      textareaClassName={s['textarea']}
    />
  );
};
OriginalUrlsWhitelistField.displayName = 'OriginalUrlsWhitelistField';

export default OriginalUrlsWhitelistField;
